import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { webMenuCrumb } from 'utils/breadcrumbInfo';
import PageHeaderWithButton from 'screens/components/basic/PageHeaderWithButton';
import CardSimple from 'screens/components/basic/CardSimple';
import Button from 'screens/components/basic/Button';
import GenericTable from 'screens/components/advanced/GenericTable';
import Pagination from 'screens/components/basic/Pagination';
import LOOKUP from 'constants/lookup';
import { getProductGroup } from 'actions/EntityActions';
import Grid from 'screens/components/basic/Grid';
import { showError } from 'actions/CommonActions';
import WithRouter from 'custom/withRouter';


class ProductGroupPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 25,
            productList: [],
            value: 'Active',
            status: 'Active',
            linkURL: '/ecommerce/menu/add'

        }
    }

    componentWillMount() {

        this.getProductGroup();
    }

    componentWillReceiveProps(props) {
        //TODO
        //Check if the second comparasion is working. I think the references always going to be different.
        //which means, always going to be true. Need to compare the content inside of the list
        if (props.productGroupList.hasOwnProperty('list') && props.productGroupList.list !== this.props.productGroupList.list) {
            this.setState(prevState => {
                return {
                    ...prevState,
                    productList: props.productGroupList.list.map(item => {
                        return {
                            Name: item.name,
                            Description: item.description,
                            //Status: item.status == 1 ? "Active" : "Inactive",
                            Status: (item.status == 1 ? <p className="statusIconGreen m-0">Active</p> : <p className="statusIconRed m-0">Inactive</p>),
                            EditIcons: (<div>
                                <Button
                                    type="IconEditButton"
                                    onTouchTap={() => this.editProductGroup(item.id)} />
                            </div>)
                        }
                    })
                }
            });
        }
    }


    getProductGroup() {
        this.props.getProductGroup({
            branchId: this.props.branchId,
            page: this.state.activePage,
            itemsPerPage: this.state.itemsPerPage
        });
    }

    editProductGroup(id) {
        this.props.navigate(`/ecommerce/menu/edit/${id}`);
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getProductGroup
        );
    }

    /**
     * String {status} - can be Active or Inactive.
     */
    setStatus = (status) => {
        if (status && status === 'Active' || status === 'Inactive') {
            this.setState(prevState => {
                return {
                    ...prevState,
                    status: status,
                    activePage: 1
                };
            }, this.getProductGroup);
        }

    }

    handleChange = (value) => {
        this.setState(pState => {
            return {
                ...pState,
                value: value
            };
        }, () => this.setStatus(value));
    };

    render() {
        let ActiveProducts = this.state.productList.filter(p => p.Status == "Active");
        let InactiveProducts = this.state.productList.filter(p => p.Status == "Inactive");
        let linkAdd = this.state.linkURL;

        const header = (
            <div>
                <ol className="breadcrumb">
                    <li><Link to={LOOKUP.menu.home.link}>{LOOKUP.menu.home.text}</Link></li>
                    <li>{LOOKUP.ecommerce.menu.menuList.title}</li>
                </ol>
                <h2>{LOOKUP.ecommerce.menu.menuList.title}</h2>
            </div>
        );
        return (
            <Grid headerContent={webMenuCrumb}>
                <PageHeaderWithButton title={LOOKUP.ecommerce.menu.menuList.title}>
                    <Button
                        type="AddButton"
                        mini
                        className="bg-light-green"
                        label="ADD NEW MENU"
                        onTouchTap={() => this.props.navigate(linkAdd)}
                    />
                </PageHeaderWithButton>
                <CardSimple>
                    <GenericTable
                        className="table_center tableHeaderwhiteColorFont"
                        tableBodyClassName="productgroup-table"
                        multiSelectable={false}
                        enableSelectAll={false}
                        selectable={false}
                        columns={LOOKUP.ecommerce.WebmenuCategorylistTableColumns}
                        rows={this.state.productList}
                        stripedRows={true}
                    />
                    <Pagination
                        length={this.props.productGroupList.total || 0}
                        itemsPerPage={this.state.itemsPerPage}
                        activePage={this.state.activePage}
                        onPageChange={this.changePage} />
                </CardSimple>
            </Grid>
        );
    }
}
function mapStateToProps(state) {
    return {
        branchId: state.common.branchId,
        productGroupList: state.entity.productGroupList,
        isMedical: state.common.applicationSettings.isMedical
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getProductGroup: model => dispatch(getProductGroup(model)),
        showError: (message) => dispatch(showError(message))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(ProductGroupPage));
